/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { createContext, useState, useMemo } from 'react'
import PropTypes from 'prop-types'

export const ModalContext = createContext(null)

const ModalContextProvider = (props) => {
  const [mobileNumberModal, setMobileNumberModal] = useState(false)
  const [otpModal, setOtpModal] = useState(false)
  const [nicModal, setNicModal] = useState(false)
  const [purchaseCompleteModal, setPurchaseCompleteModal] = useState(false)
  const [purchaseConfirmModal, setPurchaseConfirmModal] = useState(false)

  const valueProvider = useMemo(() => ({
    mobileNumberModal,
    setMobileNumberModal,
    otpModal,
    setOtpModal,
    nicModal,
    setNicModal,
    purchaseCompleteModal,
    setPurchaseCompleteModal,
    purchaseConfirmModal,
    setPurchaseConfirmModal
  }), [mobileNumberModal, otpModal, nicModal, purchaseCompleteModal, purchaseConfirmModal])

  return (
    <ModalContext.Provider value={valueProvider}>
      {props.children}
    </ModalContext.Provider>
  )
}

ModalContextProvider.propTypes = {
  children: PropTypes.element
}

export default ModalContextProvider
